import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import type { GoToastOptions } from '@go-modules/interfaces/go-toast-options';

@Injectable({
	providedIn: 'root'
})
export class NgxGoToastService {
	private _toastSubject = new Subject<GoToastOptions>();

	constructor () {}

	public get toastObserver (): Observable<GoToastOptions> {
		return this._toastSubject.asObservable();
	}

	public createToast (toastOptions: GoToastOptions) {
		this._toastSubject.next(toastOptions);
	}
}
